import { BaseModel } from 'src/app/shared/models/base.model';

export class Quote extends BaseModel{
    static fromJsonToObject(jsonData:any):Quote{
        return Object.assign(new Quote(), jsonData)
    }
}